import React from 'react';
import { ISkillCategory } from 'shared/interfaces/ISkills';
import { ItemContainer } from '../../Skills.styles';
import { MainCont, CategoryHeader } from '../SkillComponents.style';
import SkillGroupComponent from '../SkillGroupComponent';

interface Props {
  data: ISkillCategory;
}

const Sports: React.FC<Props> = ({ data }) => {
  return (
    <MainCont>
      <CategoryHeader>Select Sports</CategoryHeader>
      <ItemContainer>
        <SkillGroupComponent category={'Sports'} groupsData={data?.groups} />
      </ItemContainer>
    </MainCont>
  );
};

export default Sports;
